import { loadConfig } from '../config';

export default function globalScript() {
  loadConfig();
}
